/**
 * 帶入題（questionMappings 的目標題）答案重新對位。
 *
 * 帶入題選項的 value 是「來源題勾選子集合內的序位（0..n-1）」，來源題一改，
 * 同一個選項的序位就會變。這裡用 origin_op（選項在來源題的原始索引）把舊答案
 * 對到新序位：
 * - 原本選的選項還在 → 回傳它的新 value
 * - 已不存在 → 拿掉（單選回傳 undefined；複選只留還在的，全沒了回傳 undefined）
 *
 * @param prevValue  目標題目前的答案（單選為 value，複選為 value 陣列）
 * @param prevSlots  重建前的 choiceIndexMapRef.current[目標題]
 *                   （{ [value]: { index, title, origin_op, origin_qi } }）
 * @param newChoices 重建後的 choices（[{ value, text, origin_op, origin_qi }]）
 * @returns 新答案；undefined 代表應清空
 */
export function remapBringInAnswer(prevValue, prevSlots, newChoices) {
  const remapOne = (v) => {
    // 目標題自己的「其他」/「以上皆無」不是帶入選項，原樣保留
    if (v === 'other' || v === 'none') return v
    const slot = prevSlots?.[v]
    if (!slot || typeof slot !== 'object') return undefined
    const hasOriginOp = slot.origin_op !== undefined && slot.origin_op !== null
    const found = newChoices.find((c) =>
      hasOriginOp ? c.origin_op === slot.origin_op : c.text === slot.title
    )
    return found ? found.value : undefined
  }

  if (Array.isArray(prevValue)) {
    const next = prevValue.map(remapOne).filter((v) => v !== undefined)
    return next.length > 0 ? next : undefined
  }
  if (prevValue === undefined || prevValue === null || prevValue === '') {
    return undefined
  }
  return remapOne(prevValue)
}
